import { render, staticRenderFns } from "./TableauxBord.vue.vue?vue&type=template&id=33eefb46&"
import script from "./TableauxBord.vue.vue?vue&type=script&lang=js&"
export * from "./TableauxBord.vue.vue?vue&type=script&lang=js&"
import style0 from "./TableauxBord.vue.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports